<template>
  <modal @close="$emit('fechar')">
    <form @submit.prevent="confirmar" class="formulario">
      <h3 class="titulo titulo_medio u-margem-inferior-media">Alterar NUP</h3>
      <hr class="u-margem-inferior-grande" />
      <div class="grade__linha" v-if="projetoExigeNumeroDoProcesso">
        <div class="grade__coluna">
          <label class="label" for="numeroDoProcesso">Processo NUP</label>
          <input
            type="text"
            v-model="novoNumeroDoProcesso"
            name="numeroDoProcesso"
            id="numeroDoProcesso"
            placeholder="XX/XXX.XXX/XXXX"
            v-mask="'99/999.999/9999'"
            required
          />
        </div>
      </div>
      <hr class="u-margem-superior-grande u-margem-inferior-media" />
      <div class="grade__linha_alinhar-horizontal-direita formulario-button">
        <button
          type="button"
          @click="$emit('fechar')"
          class="botao botao_contorno botao_medio botao_cor-cinza u-margem-direita-pequena"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="botao botao_cor-terciaria botao_medio"
          :class="{ 'is-loading': carregando }"
          :disabled="!novoNumeroDoProcesso"
        >
          Salvar
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import AwesomeMask from "awesome-mask";
import Modal from "../../../shared/Modal";

export default {
  name: "modal-alterar-nup",
  components: { Modal },
  directives: { mask: AwesomeMask },
  props: {
    carregando: { type: Boolean, default: false },
    projetoExigeNumeroDoProcesso: { type: Boolean, default: false },
  },
  data() {
    return {
      novoNumeroDoProcesso: null,
    };
  },
  methods: {
    confirmar() {
      this.$emit("confirmar", this.novoNumeroDoProcesso);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ModalAlterarNup.vue?b37f5c98